import { render, staticRenderFns } from "./gasLeakDetectionAlarmInfo.vue?vue&type=template&id=3d1fd7b6"
import script from "./gasLeakDetectionAlarmInfo.vue?vue&type=script&lang=js"
export * from "./gasLeakDetectionAlarmInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1fd7b6')) {
      api.createRecord('3d1fd7b6', component.options)
    } else {
      api.reload('3d1fd7b6', component.options)
    }
    module.hot.accept("./gasLeakDetectionAlarmInfo.vue?vue&type=template&id=3d1fd7b6", function () {
      api.rerender('3d1fd7b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/glda/gasLeakDetectionAlarmInfo.vue"
export default component.exports